<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                                             :table-items="tableItems"
                                             @load-items="getTableData"
                                             @delete-items="deleteItems"
                                             @new-item="goToDetail"
                                             @row-click="goToDetail"
                                             ref="gofixTable">

                            <template slot="gofix_table:reasons" slot-scope="row">
                                <div v-html="row.item.reasons"></div>
                            </template>
                            <template slot="gofix_table:ld_date" slot-scope="row">
                                {{row.item.ld_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>

                            <template slot="gofix_table:total" slot-scope="row">
                                {{ row.item.total | formatMoney }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    export default {
        name: 'liquidated-damages',
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['liquidated_damages']));
            return {
                tableConfig:{
                    name: 'liquidated-damages-listing',
                    controls:{
                        create: this.$checkRole(this.$accessModule.liquidated_damages, 'create'),
                        delete: this.$checkRole(this.$accessModule.liquidated_damages, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems: [],
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        created(){},
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("LiquidatedDamagesController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('LiquidatedDamagesController/deleteItems', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'liquidated_damages'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            goToDetail(item){
                let id = item ? item.id : 0;
                if(id){
                    this.$router.push({name:"liquidated-damages-detail",params:{id:id}});
                }else{
                    this.$router.push({name:"liquidated-damages-detail",params:{id:id}});
                }
            }
        }
    }
</script>
